/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid } from "../../clients/classPlanningGradeAndFrequenceConfigurationController/getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid.ts";

export const getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryKey =
  (
    classStudentId: GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams["classStudentId"],
  ) =>
    [
      {
        url: "/api/v1/classroomdiscipline/grade-and-frequence/class-students/:classStudentId",
        params: { classStudentId: classStudentId },
      },
    ] as const;

export type GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryKey =
  ReturnType<
    typeof getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryKey
  >;

export function getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryOptions(
  classStudentId: GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams["classStudentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryKey(
      classStudentId,
    );
  return queryOptions<
    GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500
    >,
    GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
    typeof queryKey
  >({
    enabled: !!classStudentId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid(
        classStudentId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os Módulos da Turma com as Turmas associadas e as Disciplinas (Aulas + exame) organizadas por Disciplina. **(Requer Authorization para autenticação)**
 * @summary Dados de média e frequência da Turma (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-students/:classStudentId}
 */
export function useGetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid<
  TData =
    GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
  TQueryData =
    GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryKey,
>(
  classStudentId: GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidPathParams["classStudentId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401
          | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404
          | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryKey(
      classStudentId,
    );

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentidQueryOptions(
        classStudentId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid401
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid404
      | GetApiV1ClassroomdisciplineGradeAndFrequenceClassStudentsClassstudentid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
